import React, { useMemo } from 'react';
import SearchableSelect from 'components/common/SearchableSelect';

const FiltrosCategoria = ({
  contas = [],
  selectedPlanejamento,
  setSelectedPlanejamento,
  selectedSubcategoria,
  setSelectedSubcategoria,
  inline = true
}) => {
  const planejamientos = useMemo(() => {
    const set = new Set();
    contas.forEach(c => {
      const p = (c.planejamento || 'Sem planejamento').trim();
      if (p) set.add(p);
    });
    return Array.from(set).sort((a, b) => a.localeCompare(b, 'pt-BR'));
  }, [contas]);

  const subcategorias = useMemo(() => {
    const set = new Set();
    contas.forEach(c => {
      const matchPlanejamento = selectedPlanejamento ? (c.planejamento || 'Sem planejamento') === selectedPlanejamento : true;
      if (!matchPlanejamento) return;
      const s = (c.conta_analitica || 'Sem subcategoria').trim();
      if (s) set.add(s);
    });
    return Array.from(set).sort((a, b) => a.localeCompare(b, 'pt-BR'));
  }, [contas, selectedPlanejamento]);

  const planejamentoOptions = useMemo(
    () => planejamientos.map((p) => ({ id: p, label: p })),
    [planejamientos]
  );
  const subcategoriaOptions = useMemo(
    () => subcategorias.map((s) => ({ id: s, label: s })),
    [subcategorias]
  );

  const content = (
      <div className="flex flex-col lg:flex-row lg:items-start gap-4">
        <div className="flex-1 min-w-0 lg:min-w-[220px]">
          <label className="block text-sm font-medium text-[color:var(--text-muted)] mb-1">Categoria (Planejamento)</label>
          <div className="flex items-center gap-2">
            <SearchableSelect
              options={planejamentoOptions}
              value={selectedPlanejamento ? { id: selectedPlanejamento, label: selectedPlanejamento } : { id: '', label: 'Todas' }}
              onChange={(opt) => {
                const val = opt?.id ? opt.id : null;
                setSelectedPlanejamento(val);
                // Reset subcategoria when changing planejamento
                setSelectedSubcategoria(null);
              }}
              placeholder="Todas"
              searchFields={['label', 'id']}
            />
            {selectedPlanejamento && (
              <button
                type="button"
                className="inline-flex min-h-[44px] items-center justify-center px-3 py-2 text-xs text-[color:var(--text-muted)] bg-[color:var(--surface-muted)] rounded-lg hover:bg-[color:var(--surface)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--accent)] focus-visible:ring-offset-2 focus-visible:ring-offset-[color:var(--surface)]"
                onClick={() => setSelectedPlanejamento(null)}
              >
                Limpar
              </button>
            )}
          </div>
        </div>

        <div className="flex-1 min-w-0 lg:min-w-[220px]">
          <label className="block text-sm font-medium text-[color:var(--text-muted)] mb-1">Subcategoria (Conta Analítica)</label>
          <div className="flex items-center gap-2">
            <SearchableSelect
              options={subcategoriaOptions}
              value={selectedSubcategoria ? { id: selectedSubcategoria, label: selectedSubcategoria } : { id: '', label: 'Todas' }}
              onChange={(opt) => setSelectedSubcategoria(opt?.id ? opt.id : null)}
              placeholder="Todas"
              searchFields={['label', 'id']}
            />
            {selectedSubcategoria && (
              <button
                type="button"
                className="inline-flex min-h-[44px] items-center justify-center px-3 py-2 text-xs text-[color:var(--text-muted)] bg-[color:var(--surface-muted)] rounded-lg hover:bg-[color:var(--surface)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--accent)] focus-visible:ring-offset-2 focus-visible:ring-offset-[color:var(--surface)]"
                onClick={() => setSelectedSubcategoria(null)}
              >
                Limpar
              </button>
            )}
          </div>
          {selectedPlanejamento && (
            <p className="mt-1 text-xs text-[color:var(--text-muted)]">Filtrado por: {selectedPlanejamento}</p>
          )}
        </div>
      </div>
  );
  
  if (inline) return content;
  return (
    <div className="bg-[color:var(--surface)] rounded-xl p-6 shadow-sm border border-[color:var(--border)] mb-6">{content}</div>
  );
};

export default FiltrosCategoria;




